module.exports = __webpack_public_path__ + "static/media/TheGhostsofBitterflyBay_Bookcover.b1dfbe97.jpg";